/* eslint-disable */
import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import SubEventList from "components/EventComponents/EventDetailsComponents/SubEventComponents/SubEventList/SubEventList";

const SubEvents = () => {
  useEffect(() => {
    document.title = "Sub Events";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="events" />
      <SubEventList />
    </main>
  );
};

export default SubEvents;
